import {EventEmitter, Injectable} from '@angular/core';
import {IConnectorsEdges, IIconData, ITagretsNodes, TGraphType,} from '../models/graph-kn.model-interfaces';
import {Group} from 'konva/lib/Group';
import {GraphKnDataService} from './graph-kn.data.service';
import {GraphKnUIElementsService} from './graph-kn.ui.elements.service';
import {Arrow} from 'konva/lib/shapes/Arrow';
import {IKnGraphSettings, IKnUIOptions} from '../models/graph-kn.cm-api-models';
import {Layer} from 'konva/lib/Layer';
import {ARROW_DAGRE_POINTER_HEIGHT,  ARROW_DAGRE_POINTER_WIDTH,  ARROW_STROKE_WIDTH_Base} from '../models/graph-kn.cm.arrows-model-const';
import { EEdgyType, ELayoutAlgorithms, EdgePointerType, Position } from '../models/graph-kn.model-enums';
import { Line } from 'konva/lib/shapes/Line';
import { IXYNode, XYEdgeService } from './xyflow-edge.service';
import { ARROW_COLOR_Base } from '../styles/graph-colors';
import { NodesStylingMap } from '../styles/nodes-styles/graph-node--map-styles-root';
import { INodeStyleConfing } from '../models/graph-kn.cm.nodes-model-const';
@Injectable({
    providedIn: 'root'
})
export class GraphKnEdgeService {
	public emitEdgeEvent: EventEmitter<IConnectorsEdges> = new EventEmitter<IConnectorsEdges>();

	constructor(
			private knDataService: GraphKnDataService,
			private knUIElementsService: GraphKnUIElementsService,
			private xyEdgeService: XYEdgeService,
	) {
	}
    createEdgesRoot(connectorsEdges:IConnectorsEdges[],graphLayer:Layer,targetsNodes:ITagretsNodes[],graphSettings?:IKnGraphSettings,layerId?:TGraphType) {
        connectorsEdges.forEach(connect => {
            switch (graphSettings?.layoutAlgorithm) {
                case ELayoutAlgorithms.Darge:
                    this.createDagreLabelEdge(graphLayer,connect,graphSettings.edgePointerType||EdgePointerType.Arrow);
                break;
                case ELayoutAlgorithms.Local:
                    this.createLocalEdge4Points(
                        graphLayer,targetsNodes,connect,
                        graphSettings.edgeType||EEdgyType.SmoothStep ,graphSettings.edgePointerType||EdgePointerType.Arrow
                    );
                break;
                case ELayoutAlgorithms.ELK:
                    let settingsUI = layerId? this.knDataService.graphUISetting.get(layerId) : {}
                    this.createELKEdge(graphLayer,connect,graphSettings.edgePointerType||EdgePointerType.Arrow, settingsUI);
                break;
            }
		});
    }
	createLocalEdge4Points(
		graphLayer: Layer, targetsNodes:ITagretsNodes[],connect:IConnectorsEdges,
		edgeType: EEdgyType,edgePointerType:EdgePointerType,
	) {
    let sourceNode = targetsNodes.find(el=>el.node.id === connect.from)
		let targetNode = targetsNodes.find(el=>el.node.id === connect.to)
		if (sourceNode && targetNode) {
			let source:IXYNode = {
				x:sourceNode.x,
				y:sourceNode.y,
				id:sourceNode.node.id,
                width:sourceNode.node.dimension.width,
                height:sourceNode.node.dimension.height
			}
			let target:IXYNode = {
				x:targetNode.x,
				y:targetNode.y,
				id:targetNode.node.id,
                width:targetNode.node.dimension.width,
                height:targetNode.node.dimension.height
			}
			let newPathGroup = this.xyEdgeService.prepareXYEdge(source,target,connect.id,edgeType,edgePointerType,connect.points_labels,connect)
			newPathGroup.path? graphLayer.add(newPathGroup.path) : null
			newPathGroup.pointer? graphLayer.add(newPathGroup.pointer) : null
		}
	}
	createELKEdge(graphLayer: Layer, connect:IConnectorsEdges,edgePointerType:EdgePointerType,settingsUI?:IKnUIOptions) {
		let pointsLabelBezier =[...connect.points_labels!]
		let flatPointsLabelBezier=pointsLabelBezier.map(el=>[el.x,el.y]).flat()
		let arrowGroup = new Group ({})
		let lineDagreBezierLabel =  new Line({
			id:connect.id + '_edge_path',
			points:flatPointsLabelBezier,
			stroke:ARROW_COLOR_Base,
			strokeWidth:ARROW_STROKE_WIDTH_Base,
			bezier:false,
		})
		arrowGroup.add(lineDagreBezierLabel)
		if (settingsUI?.showDeleteEdge) {
			let emitter = (): void => {
					return this.emitEdgeEvent.emit({
							...connect,
							id: connect.edge_id||'',
							data: {
									target: connect.to,
									source: connect.from
							}
					})
			}
            let cssConfig = connect.nodeType? NodesStylingMap.get(connect.nodeType) as INodeStyleConfing: null
			let cssDeleteButton = cssConfig?.edgeDeletButton
            if (cssConfig && cssDeleteButton) {
                let buttonPostion = this.knUIElementsService.calcDeleteButtonPostion(flatPointsLabelBezier,cssConfig)
                let iconDeleteData:IIconData = {
                    id:connect.id +'DeleteButton',
                    iconPath:cssDeleteButton.iconPath,
                    position:{
                        x:buttonPostion.x,
                        y:buttonPostion.y
                    },
                    iconBackGroundColor:cssDeleteButton.iconBackGroundColor,
                    offsetX:(cssDeleteButton.iconHeight - cssDeleteButton.iconBackGroundHeight)/2,
                    offsetY:(cssDeleteButton.iconHeight - cssDeleteButton.iconBackGroundHeight)/2,
                    iconHeight:cssDeleteButton.iconHeight,
                    iconBackGroundHeight:cssDeleteButton.iconBackGroundHeight,
                    iconBackGroundRadius:cssDeleteButton.iconRadius,
                    activeIcon:cssDeleteButton.activeIcon
                }
                let iconGroup = this.knUIElementsService.createIcon(iconDeleteData)
                iconGroup.hide()
                iconGroup.on('click',emitter)
                arrowGroup.add(iconGroup)
            }
		}
		this.createDagreLabelEdgePointer(arrowGroup,connect,edgePointerType)
		graphLayer.add(arrowGroup)
	}
	createDagreLabelEdge(graphLayer: Layer, connect:IConnectorsEdges,edgePointerType:EdgePointerType) {
		let pointsLabelBezier =[...connect.points_labels!];
	  pointsLabelBezier.forEach((el,index) => index % 2>0 ? pointsLabelBezier.splice(index,0,pointsLabelBezier[index]) : null);
		let flatPointsLabelBezier=pointsLabelBezier.map(el=>[el.x,el.y]).flat();
		let lineDagreBezierLabel =  new Line({
			id:connect.id + '_edge_path',
			points:flatPointsLabelBezier,
			stroke:ARROW_COLOR_Base,
			strokeWidth:ARROW_STROKE_WIDTH_Base,
			//bezier:false,
			bezier:true
		});
		graphLayer.add(lineDagreBezierLabel);
		this.createDagreLabelEdgePointer(graphLayer,connect,edgePointerType)
	}
	createDagreLabelEdgePointer (arrowGroup: Group, connect:IConnectorsEdges, edgePointerType:EdgePointerType) {
		switch (edgePointerType) {
			case EdgePointerType.Arrow:
				let pointsLabelSharpAngle = connect.points_labels?.map(el=>[el.x,el.y]).flat()
				if (pointsLabelSharpAngle) {
					let noBendLineDagreLabel =  new Arrow({
						id:connect.id + '_edge_pointer',
                        name:'Arrow',
						points:pointsLabelSharpAngle,
						fill:ARROW_COLOR_Base,
						//stroke:'red',
						pointerWidth:ARROW_DAGRE_POINTER_WIDTH,
						pointerLength:ARROW_DAGRE_POINTER_HEIGHT,
						strokeWidth:1,
						//bezier:true
					})
					arrowGroup.add(noBendLineDagreLabel)
				}
				break;
				default:
					let lastPoint = connect.points_labels?.length? connect.points_labels[connect.points_labels?.length-1] : null;
					let pointer = lastPoint? this.xyEdgeService.createConnectPoint(lastPoint,Position.Left,connect.id,edgePointerType) : null;
					pointer? arrowGroup.add(pointer) : null;
				break;
		}

	}
	addEventHandlerToEdgeGroup(lineDagre: Arrow, delHoverButton: Group, arrowGroup: Group, delHoverButtonTip: Group) {
			lineDagre.on('mouseover', (e) => {
					arrowGroup.moveToTop()
					document.body.style.cursor = 'pointer'
					delHoverButton ? delHoverButton.absolutePosition({x: e.evt.offsetX - 13, y: e.evt.offsetY - 13}) : null;
					delHoverButtonTip.absolutePosition({x: e.evt.offsetX, y: e.evt.offsetY + delHoverButtonTip.height()})
					delHoverButtonTip.show()
					delHoverButton ? delHoverButton.show() : null;
					lineDagre.opacity(0.7)
			})
			lineDagre.on('mouseout', () => {
					arrowGroup.moveDown()
					delHoverButton ? delHoverButton.hide() : null;
					document.body.style.cursor = 'default'
					lineDagre.opacity(1)
			})
			if (delHoverButton) {
					arrowGroup.add(delHoverButton);
			}
	}
}